<template>
  <div
    class="search-input-button"
    :class="{single:single,'mt-Md':isMtMd}"
  >
    <i class="search-input-button_leading-icon icon-search" />
    <input
      tabindex="0"
      type="text"
      :value="value"
      :placeholder="placeholder"
      @input="inputOnchange($event)"
      @keyup.enter="WsButton001Onclick()"
    >
    <WsButton001 @click="WsButton001Onclick()">
      {{ textLabel }}
    </WsButton001>
  </div>
</template>

<script>
export default {
  name: "LlSearchInputButton",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    single: {
      type: Boolean,
      default: false,
    },
    isMtMd: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    inputOnchange($event) {
      this.$emit("input", $event.target.value);
      if (!$event.target.value) {
        this.$emit("click");
      }
    },
    WsButton001Onclick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/search-input-button";
</style>